import React from "react";
import PropTypes from "prop-types";
import Select, { components as RSComponents } from "react-select";
import "./index.scss";
function SelectComponent(Props) {
  const {
    handleChange,
    options,
    optionValues,
    name,
    selectedValue,
    disabled,
    label,
    labelClass,
    required,
    placeholder,
    activeWithoutValue,
    isSearchable = false,
    isClearable = true,
    mandatory = false,
    mandatoryAsterisk = false,
    isMulti = false,
    components,
    hideSelectedOptions,
    closeMenuOnSelect,
    joinMultiValues,
  } = Props;

  const optionsData = () => {
    return options.map((val, ind) => {
      return {
        value: !!optionValues ? optionValues[ind] : val,
        label: val,
      };
    });
  };

  const selectClasses = ""; // (selectedValue || activeWithoutValue) ? "form-select select-active" : "form-select select-disable"
  const handleFieldChange = (data) => {
    if (isMulti) {
      handleChange(data ? data.map((d) => d.value) : []);
    } else {
      handleChange(data ? data.value : "");
    }
  };

  const selectedOptionValue = isMulti
    ? optionsData().filter(
        (a) =>
          selectedValue &&
          (selectedValue.includes(a.value) || selectedValue.includes(a.label))
      )
    : (selectedValue
        ? optionsData().find(
            (a) => a.value === selectedValue || a.label === selectedValue || a.value == selectedValue
          )
        : null) || null;

  const customComponents = { ...components };
  if (mandatory) {
    customComponents.Placeholder = (props) => {
      return (
        <RSComponents.Placeholder {...props}>
          <span className="mandatory-asterisk" style={{ color: "#be1e2d", marginRight: "3px", fontSize: "11px", position: "relative", top: "-2px" }}>*</span>
          {props.children}
        </RSComponents.Placeholder>
      );
    };
  }
  if (joinMultiValues) {
    customComponents.MultiValue = () => null;
    customComponents.ValueContainer = ({ children, ...props }) => {
      const selected = props.getValue();
      return (
        <RSComponents.ValueContainer {...props}>
          {selected.length > 0 && (
            <div
              style={{
                position: "absolute",
                pointerEvents: "none",
                paddingLeft: "2px",
                maxWidth: "calc(100% - 60px)",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                color: "hsl(0, 0%, 20%)",
                zIndex: 1,
                fontSize: "14px",
              }}
            >
              {selected.map((s, idx) => (
                <React.Fragment key={idx}>
                  <span>{s.label}</span>
                  {idx < selected.length - 1 && (
                    <span style={{ margin: "0 6px" }}>|</span>
                  )}
                </React.Fragment>
              ))}
            </div>
          )}
          {children}
        </RSComponents.ValueContainer>
      );
    };
  }

  return (
    <div className="">
      {labelClass !== "none" && (
        <label className={labelClass}>
          {label}{" "}
          {mandatory && (
            <span className="option-badge mandatory-span badge">Mandatory</span>
          )}{" "}
          {mandatoryAsterisk && <small className="input-required">*</small>}{" "}
        </label>
      )}
      <Select
        classNamePrefix="reactSelect"
        placeholder={placeholder || "Select"}
        required={required}
        isDisabled={disabled}
        className={"reactSelect-container " + selectClasses}
        onChange={handleFieldChange}
        name={name}
        isSearchable={isSearchable}
        isClearable={isClearable}
        options={optionsData()}
        value={selectedOptionValue}
        isMulti={isMulti}
        components={customComponents}
        hideSelectedOptions={hideSelectedOptions}
        closeMenuOnSelect={closeMenuOnSelect}
      />
    </div>
  );
}

SelectComponent.propTypes = {
  handleChange: PropTypes.func,
  selectedvalue: PropTypes.string,
  options: PropTypes.arrayOf(PropTypes.string),
  name: PropTypes.string,
  selectedValue: PropTypes.string,
  disabled: PropTypes.bool,
  labelClass: PropTypes.string,
  label: PropTypes.string,
  required: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  placeholder: PropTypes.string,
  activeWithoutValue: PropTypes.bool,
};

SelectComponent.defaultProps = {
  handleChange: () => null,
  selectedvalue: "",
  options: [],
  name: "",
  selectedValue: "",
  disabled: false,
  labelClass: "hidden",
  label: "label",
  required: false,
  placeholder: "",
  activeWithoutValue: false,
};

export default SelectComponent;
